/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationPeopleManagementAliases {
  FRAGMENT_0 = 'fragment-0',
  PANEL_0 = 'panel-0',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_WITH_CONTENT_0 = 'tab-with-content-0',
  TAB_WITH_CONTENT_1 = 'tab-with-content-1',
  TAB_WITH_CONTENT_2 = 'tab-with-content-2',
}
export { ProviderAccreditationPeopleManagementAliases };
